import { HOSTS } from "../utils/constants"

export const getHost = (region) => {
    return HOSTS[region] || HOSTS["us"]
}